import { z } from 'zod';
import { IsoTimestamp } from './common';

export const TriageMode = z.enum(['manual', 'scheduled', 'event']);
export type TriageMode = z.infer<typeof TriageMode>;

export const TriageSessionStatus = z.enum([
  'in_progress',
  'paused_for_input',
  'aborted',
  'completed',
]);
export type TriageSessionStatus = z.infer<typeof TriageSessionStatus>;

export const PrRecord = z.object({
  prNumber: z.number().int(),
  findingId: z.string().uuid(),
  branch: z.string(),
  title: z.string(),
  ciStatus: z.enum(['pending', 'green', 'red']).default('pending'),
  mergeState: z.enum(['open', 'merged', 'closed', 'blocked']).default('open'),
  openedAt: IsoTimestamp,
});
export type PrRecord = z.infer<typeof PrRecord>;

export const TriageSession = z.object({
  sessionId: z.string().uuid(),
  mode: TriageMode,
  actorEmail: z.string().email(),
  actorUserId: z.string(),
  allowAutoMerge: z.boolean(),
  findingsExamined: z.array(z.string().uuid()),
  prsOpened: z.array(PrRecord),
  status: TriageSessionStatus,
  startedAt: IsoTimestamp,
  completedAt: IsoTimestamp.optional(),
  pauseReason: z.string().optional(),
  ttl: z.number().int(), // 90-day epoch — DynamoDB TTL
});
export type TriageSession = z.infer<typeof TriageSession>;

export const StartTriageSessionRequest = z.object({
  findingIds: z.array(z.string().uuid()).min(1).max(50),
  allowAutoMerge: z.boolean().default(false),
  mode: TriageMode.default('manual'),
});
export type StartTriageSessionRequest = z.infer<typeof StartTriageSessionRequest>;

export const StopTriageSessionRequest = z.object({
  reason: z.string().min(1).max(500).optional(),
});
export type StopTriageSessionRequest = z.infer<typeof StopTriageSessionRequest>;

export const ReplyToSessionRequest = z.object({
  message: z.string().min(1).max(2000),
});
export type ReplyToSessionRequest = z.infer<typeof ReplyToSessionRequest>;
